<template>
  <AgGridWrapper
    ref="agGrid"
    title="Journals (publish)"
    :options="gridOptions"
    @selected-rows-entire-row="rowSelectionChanged"
  />
</template>

<script>
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  data: () => ({
    rowData: []
  }),

  computed: {
    gridOptions() {
      return {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        domLayout: 'normal',
        pagination: false,
        defaultColDef: {
          floatingFilter: true,
          filter: 'agTextColumnFilter'
        },
        rowData: this.rowData,
        columnDefs: [
          {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: 'Journal',
            field: 'journal_name',
            minWidth: 250
          },

          {
            headerName: 'Print identifier',
            field: 'print_identifier'
          },

          {
            headerName: 'Online identifier',
            field: 'online_identifier'
          },

          {
            headerName: 'Articles',
            field: 'articles_count'
          }
        ]
      }
    }
  },

  methods: {
    showLoading() {
      // access from parent
      this.$refs.agGrid.setLoading(true)
    },

    setNewRows(rows) {
      this.rowData = rows.map(row => ({ ...row, preselected: true }))
      this.$refs.agGrid.updateSelectedRows()
    },

    rowSelectionChanged(rows) {
      const articleIds = rows.reduce((acc, curr) => {
        acc.push(...curr.article_ids)
        return acc
      }, [])
      this.$emit('select', articleIds)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

tableWithCheckBoxes()

>>> .table-content {
  height calc(100% - 55px)
  padding 0 40px

  .ag-theme-material {
    height  100%
  }

  .ag-center-cols-viewport {
    overflow-x hidden
  }
}
</style>
